import { motion } from "framer-motion";

const loadingVariants = {
    hidden: {
        opacity: 0,
        scale: 0.2
    },
    visible : {
        opacity: 1,
        scale: 1,
        transition: {
            yoyo: Infinity,
            duration: 0.4,
            ease: 'easeInOut',
            type: 'spring',
            mass: 0.9
        }
    }
}

const Loading = () => {
    return ( 
        <div className="main-loading-cont grey lighten-3">
            <motion.img 
                src="/img/logo.svg" 
                alt="Unspoken Logo" 
                variants={loadingVariants}
                initial="hidden"
                animate="visible"
            />

        </div>
     );
}
 
export default Loading;